var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignElement1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10165",
    "data-name": "Group 10165",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5652",
    "data-name": "Rectangle 5652",
    width: 492,
    height: 225.688,
    fill: "#244277"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10163",
    "data-name": "Group 10163",
    transform: "translate(368.688 10) rotate(90)",
    opacity: 0.705
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10069",
    "data-name": "Group 10069",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M50.365,225.688C53,126.662,139.582,47.147,246,47.147s193,79.516,195.633,178.541H492C489.354,100.622,380.236,0,246,0S2.651,100.622,0,225.688Z",
    transform: "translate(0 0)",
    fill: "#244277"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5680",
    "data-name": "Rectangle 5680",
    width: 512,
    height: 512,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignElement1);
export default __webpack_public_path__ + "static/media/designElement1.d88e46f4d854572312871b5fda2314a8.svg";
export { ForwardRef as ReactComponent };